import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "../context/site";
import { Eyebrow, Cta, MarkTile } from "../components/site/kit";
import { NextSteps, Pager } from "../components/site/extras";
import FindYourSwitch from "../components/site/FindYourSwitch";

export default function FindYourSwitchPage() {
  const { openDiagnostic, openTalk } = useSite();
  return (
    <div className="font-body bg-white">
      <section className="bg-black pb-24 pt-36 text-white md:pt-44">
        <div className="mx-auto max-w-[1360px] px-6 md:px-12 lg:px-16">
          <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
            <ol className="flex flex-wrap items-center gap-2 font-body text-xs font-semibold uppercase tracking-[0.14em] text-white/50">
              <li><Link to="/" className="transition-colors hover:text-[#5f8f10]">Home</Link></li>
              <li className="flex items-center gap-2"><span aria-hidden className="text-white/30">/</span><span className="text-[#5f8f10]">Find Your Switch</span></li>
            </ol>
          </nav>
          <div className="grid items-center gap-12 md:grid-cols-12">
            <div className="md:col-span-7">
              <Eyebrow dark>Find Your Switch</Eyebrow>
              <h1 className="font-display mt-6 max-w-[16ch] text-5xl leading-[0.92] tracking-tight md:text-7xl lg:text-8xl">
                Start with the <span className="text-[#5f8f10]">symptom.</span>
              </h1>
              <p className="font-body mt-8 max-w-2xl text-xl font-normal leading-relaxed text-white/90">
                Describe what is happening in your business, and we&rsquo;ll point you to the most relevant growth situation and the SWITCH thinking that fits.
              </p>
            </div>
            <div className="md:col-span-5">
              <MarkTile src="/assets/page-find-your-switch.png" />
            </div>
          </div>
        </div>
      </section>
      <section className="border-b-2 border-[#5f8f10] bg-black text-white">
        <div className="mx-auto max-w-[1360px] px-6 py-20 md:px-12 lg:px-16">
          <FindYourSwitch onOpenDiagnostic={openDiagnostic} bare />
        </div>
      </section>
      <section className="bg-white">
        <div className="mx-auto grid max-w-[1360px] items-center gap-10 px-6 py-24 md:grid-cols-12 md:px-12 md:py-28 lg:px-16">
          <h2 className="font-display md:col-span-8 text-4xl leading-[0.95] tracking-tight text-black md:text-5xl">
            Prefer to talk it through?
          </h2>
          <div className="md:col-span-4 md:flex md:justify-end">
            <Cta onClick={() => openTalk()} testId="fys-page-contact-cta">Bring Us Your Growth Problem</Cta>
          </div>
        </div>
      </section>

      <NextSteps links={[
        { eyebrow: "What we solve", title: "Four ways growth gets stuck", blurb: "Enter by the growth problem in front of you.", href: "/what-we-solve" },
        { eyebrow: "How we work", title: "The SWITCH model", blurb: "The four moves that turn a growth problem into growth.", href: "/how-we-work" },
        { eyebrow: "Our work", title: "Proof, not promises", blurb: "See the thinking applied to real businesses.", href: "/our-work" },
      ]} />

      <Pager current="/find-your-switch" />
    </div>
  );
}
